// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G1KbM","rootNoMargin":"styles_rootNoMargin__3yQ3K"};